import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { OffersBanner } from '../../components/OffersBanner';
import { useOfferBookingFormModalEnabled } from '../../hooks/offerBookingFormModal';
import { getIsAuthenticated } from '../../selectors/newbuilding';
import { TThunkDispatch } from '../../types/redux/thunk';
import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';

export const OffersBannerContainer: React.FC = () => {
  const isOfferBookingFormModalEnabled = useOfferBookingFormModalEnabled();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const dispatch: TThunkDispatch = useDispatch();
  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);

  const handleClick = React.useCallback(() => {
    if (isAuthenticated) {
      startMicrofrontOpening('offersBanner');

      return;
    }

    dispatch(
      requestAuthentication({
        onSuccess: () => () => startMicrofrontOpening('offersBanner'),
      }),
    );
  }, [dispatch, isAuthenticated, startMicrofrontOpening]);

  if (!isOfferBookingFormModalEnabled) {
    return null;
  }

  return <OffersBanner loading={loadingPlace === 'offersBanner'} onClick={handleClick} />;
};
